const defaultState = {};

const application = (state = defaultState, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

export default application;
